import MyrewardsContainer from './container/myrewardsContainer';
import { useSelector } from 'react-redux';
import { Spinner } from '../_shared/index.js';
import MilestoneClaimPopups from '../_shared/components/milestone-gift-modal/MilestoneClaimPopups.jsx';
import useMilestoneClaims from '../_shared/components/milestone-gift-modal/useMilestoneClaims.js';

const Myrewards = () => {
	const currentUser = useSelector((state) => state.user.currentUser);
	const milestone = useMilestoneClaims(currentUser);

	if (!currentUser?.company) return <Spinner />;
	return (
		<>
			<MilestoneClaimPopups currentUser={currentUser} milestone={milestone} />
			<MyrewardsContainer milestone={milestone} />
		</>
	);
};

export default Myrewards;
